import { useInfiniteQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { getArtist } from "../api";
import { ErrorBox, Loading } from "../components/State";
import { TrackRow } from "../components/TrackRow";
import { appearances, longDate, plural, yearRange } from "../format";
import { useTitle } from "../hooks";

const PAGE = 30;

export function Artist() {
  const { id = "" } = useParams();
  const q = useInfiniteQuery({
    queryKey: ["artist", id],
    initialPageParam: 0,
    queryFn: ({ pageParam }) => getArtist(id, { limit: PAGE, offset: pageParam }),
    getNextPageParam: (last) => (last.page.hasMore ? last.page.offset + PAGE : undefined),
  });
  const first = q.data?.pages[0];
  useTitle(first?.name);

  if (q.isLoading) return <Loading />;
  if (q.error || !first) return <ErrorBox error={q.error} />;
  const s = first.summary;
  const tracks = q.data?.pages.flatMap((p) => p.tracks) ?? [];

  return (
    <>
      <p className="kicker">Wykonawca</p>
      <h1>{first.name}</h1>
      {s && s.firstDate && s.lastDate && (
        <p className="lead">
          {s.tracks} {plural(s.tracks, "utwór", "utwory", "utworów")} na listach, {appearances(s.entries)},
          w latach {yearRange(s.firstDate, s.lastDate)}.
        </p>
      )}

      {first.charts.length > 0 && (
        <ul className="chips">
          {first.charts.map((c) => (
            <li key={c.chart}><Link className="chip" to={`/listy/${c.chart}/${c.lastDate}`} title={`${longDate(c.firstDate)} – ${longDate(c.lastDate)}`}>
              {c.stationName} <small>{c.tracks} {plural(c.tracks, "utwór", "utwory", "utworów")}</small>
            </Link></li>
          ))}
        </ul>
      )}

      <h2>Utwory</h2>
      <ul className="list">{tracks.map((t) => <TrackRow key={t.id} track={t} note={t.role === "featured" ? "gościnnie" : undefined} />)}</ul>
      {q.hasNextPage && (
        <button className="btn more" disabled={q.isFetchingNextPage} onClick={() => q.fetchNextPage()}>
          {q.isFetchingNextPage ? "Ładowanie…" : "Pokaż więcej"}
        </button>
      )}
    </>
  );
}
